import App from 'App';
import React from 'react';
import axios from 'axios';
import './stylesheets/tailwind.min.css';
import ReactDOM from 'react-dom/client';
import './stylesheets/application.scss';
import { AuthProvider } from 'context/useAuth';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AppSettingsContextProvider } from './context/appsettingsContext';
import { PreviouslySelectedInstallationProvider } from 'context/usePreviouslySelectedInstallation';
import { isBlockedForV3, isMutativeMethod, isReadOnly, refuseWriteAsync, setReadOnly } from 'functions/readOnly';

axios.get('./appsettings.json?t=' + Date.now()).then(settings => {

  // read only (BLOCKED_FOR_V3=yes): every API call that is not a read is refused, with the popup linking to v3's admin

  setReadOnly(isBlockedForV3(settings.data));

  axios.interceptors.request.use(async config => {
    if (isReadOnly() && isMutativeMethod(config.method)) {
      await refuseWriteAsync();
    }

    return config;
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AppSettingsContextProvider settings={settings.data}>
          <AuthProvider>
            <PreviouslySelectedInstallationProvider>
              <App />
            </PreviouslySelectedInstallationProvider>
          </AuthProvider>
        </AppSettingsContextProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
  
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.unregister();
  
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
  
}).catch((error: any) => console.error(error));